import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import { useIntl } from 'react-intl';

import ArticleHeader from '~/components/ArticleHeader';
import ContentWrapper from '~/components/ContentWrapper';
import { LanguageContext } from '~/components/LanguageProvider';
import Layout from '~/components/Layout';
import PortableText from '~/components/PortableText';

import { toPlainText } from '~/lib/helpers';

import './index.scss';
import { SmallAlertBox } from '@entur/alert';

const InformasjonOmTogIEuropa = ({ data }) => {
  const site = data?.allSanityTogreiseriutlandet?.edges?.[0]?.node;
  const { language } = React.useContext(LanguageContext);

  useEffect(() => {
    loadWidget(
      window,
      document,
      '//entur.humany.net/europa---one-widget/embed.js',
      'Humany',
      'script',
      undefined,
      undefined
    );
  }, []);

  return (
    <>
      <ArticleHeader
        title={site?.title[language]}
        excerpt={toPlainText(site?._rawExcerpt?.[language])}
      ></ArticleHeader>
      <ContentWrapper>
        <div
          id="humany_europa---one-widget"
          data-base-path="/tog-i-europa"
          style={{ marginBottom: '5rem' }}
        >
          <a href="//entur.humany.net/europa"></a>
        </div>
      </ContentWrapper>
      {site?._rawInfobox?.[language] !== undefined && (
        <ContentWrapper>
          <SmallAlertBox variant="info">
            <PortableText
              blocks={site?._rawInfobox?.[language]}
              disableScrollbarFix
            />
          </SmallAlertBox>
        </ContentWrapper>
      )}
    </>
  );
};

// This script if copied from the https://entur.humany.net/ configuration
// site and made into a named function. This is done since adding the script
// to <head> randomly makes the widget sometimes not load. This always works.

// @ts-expect-error this is formated, minified code and is not TS compliant
function loadWidget(a, b, c, d, e, f, g) {
  for (
    var h, i = /[?&]{1}(humany[^=]*)=([^&#]*)/g;
    (h = i.exec(a.location.search));

  )
    c += (-1 < c.indexOf('?') ? '&' : '?') + h[1] + '=' + h[2];
  (f = b.createElement(e)),
    (f.async = !0),
    (f.src = c),
    (g = b.getElementsByTagName(e)[0]),
    g.parentNode.insertBefore(f, g),
    (a[d] = a[d] || {
      _c: [],
      configure: function () {
        a[d]._c.push(arguments);
      },
    });
  var j = d.toLowerCase();
  a[j] = a[j] || {
    _c: [],
    configure: function () {
      a[j]._c.push(arguments);
    },
  };
}

export const query = graphql`
  query togIUtlandetIndex {
    allSanityTogreiseriutlandet {
      edges {
        node {
          title {
            nb
            nn
            en
          }
          _rawExcerpt
          _rawInfobox
        }
      }
    }
  }
`;

export default InformasjonOmTogIEuropa;
